import { Box, Button, Stack } from "@mantine/core";
import { IconBarcode, IconPrinter } from "@tabler/icons-react";
import { ReceivedCompletedAggregateIndicator } from "../sticker";

interface AccessioningPrintActionsProps {
  canPrintSticker: boolean;
  cassetteCount: number;
  completedStickerCount: number;
  isGeneratingCassettes: boolean;
  isCaseNumberAssignmentPending: boolean;
  isPrintingRequisitionLabel: boolean;
  isPrintingStickers: boolean;
  onPrintCassettes: () => void;
  onPrintRequisitionLabel: () => void;
  onPrintStickers: () => void;
  printLabelCount: number;
  showPrintCassettes: boolean;
  showPrintLabels: boolean;
  totalSlideCount: number;
}

export function AccessioningPrintActions({
  canPrintSticker,
  cassetteCount,
  completedStickerCount,
  isGeneratingCassettes,
  isCaseNumberAssignmentPending,
  isPrintingRequisitionLabel,
  isPrintingStickers,
  onPrintCassettes,
  onPrintRequisitionLabel,
  onPrintStickers,
  printLabelCount,
  showPrintCassettes,
  showPrintLabels,
  totalSlideCount,
}: AccessioningPrintActionsProps) {
  const hasVisibleAction =
    canPrintSticker ||
    showPrintCassettes ||
    showPrintLabels ||
    completedStickerCount > 0;

  if (!hasVisibleAction) return null;

  return (
    <Box
      style={{
        borderTop: "1px solid var(--mantine-color-gray-3)",
        padding: "var(--mantine-spacing-md)",
        backgroundColor: "var(--mantine-color-white)",
      }}
    >
      <Stack gap="xs">
        {completedStickerCount > 0 && (
          <ReceivedCompletedAggregateIndicator
            totalItems={totalSlideCount}
            completedItems={completedStickerCount}
          />
        )}
        {canPrintSticker && (
          <Button
            leftSection={<IconBarcode size={16} />}
            onClick={onPrintRequisitionLabel}
            loading={isPrintingRequisitionLabel}
            disabled={isCaseNumberAssignmentPending}
            variant="light"
            color="teal"
            fullWidth
          >
            Print Requisition Label
          </Button>
        )}
        {showPrintCassettes && (
          <Button
            leftSection={<IconPrinter size={16} />}
            onClick={onPrintCassettes}
            loading={isGeneratingCassettes}
            disabled={isCaseNumberAssignmentPending}
            variant="light"
            fullWidth
          >
            Print Cassettes ({cassetteCount})
          </Button>
        )}
        {showPrintLabels && (
          <Button
            leftSection={<IconPrinter size={16} />}
            onClick={onPrintStickers}
            loading={isPrintingStickers}
            disabled={isCaseNumberAssignmentPending}
            variant="outline"
            color="violet"
            fullWidth
          >
            Print Labels ({printLabelCount})
          </Button>
        )}
      </Stack>
    </Box>
  );
}
